import { useEffect, useState } from "react";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API; 

const API_BASE = `${REACT_APP_EXPRESS_API}/api/statistics`;

export function useStatistics() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(API_BASE, {
          method: "GET",
          credentials: "include"
        });

        if (!res.ok) {
          const raw = await res.json().catch(() => ({}));
          throw new Error(raw?.message || "Gagal mengambil data transaksi");
        }

        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("Error fetching stats:", err);
        setError(err.message);
      }
    })();
  }, []);

  return { stats, error };
}
